<div mat-dialog-content>
    <h3>Message</h3>
    <div style="margin:0.4rem">
    <mat-label>{{data.message}}</mat-label>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onNoClick()">Close</button>
</div>